module.exports = __webpack_public_path__ + "static/media/mobileweb_unsafecars_banner.2f498105.png";